import { render, staticRenderFns } from "./CambiarPlaza.vue?vue&type=template&id=39f087c4"
import script from "./CambiarPlaza.vue?vue&type=script&setup=true&lang=js"
export * from "./CambiarPlaza.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports